import N8nMenuItem from './MenuItem.vue';

export default N8nMenuItem;
